import React from "react";
import { Box, Button, Grid, Stack } from "@mui/material";
import styled from "styled-components";
import Logo from "src/components/header/logo";
import { Link as InternalLink } from "react-router-dom";
import welcomeImage from "../../assets/images/welcomeMailGraphicLeader.png";
import { getBaseUrl } from "../../utils/url";

const ExternalLinkStyled = styled.a`
    border-bottom: ${({ theme }) => `2px solid ${theme.palette.background.default}`};
    color: ${({ theme }) => theme.palette.primary.main};
    text-decoration: none;
    cursor: pointer;

    &:hover {
        border-bottom: ${({ theme }) => `2px solid ${theme.palette.primary.main}`};
    }
`;

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
    text-align: center;
`;

const LogInScreen = () => {
    return (
        <Box>
            <Grid container direction="column" alignItems="center">
                <Grid item mb={4}>
                    <Logo />
                </Grid>
                <Grid item mb={4}>
                    <H1>Welcome to Adadot</H1>
                </Grid>
                <Grid item mb={2}>
                    <img
                        src={welcomeImage}
                        alt=""
                        style={{ maxWidth: "100vw", maxHeight: "50vh" }}
                    />
                </Grid>
                <Grid item mb={4}>
                    <H2>Engineering Success? Predictable.</H2>
                </Grid>

                <Grid item>
                    <Stack>
                        <Button
                            as={InternalLink}
                            to="/login-username"
                            style={{ textAlign: "center" }}
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            LET&apos;S DO IT
                        </Button>

                        <ExternalLinkStyled
                            href={`${getBaseUrl()}/dashboard`}
                            style={{ textAlign: "center" }}
                            onClick={() => {
                                localStorage.setItem(
                                    "token",
                                    JSON.stringify({
                                        id_token:
                                            "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCIsImtpZCI6IkVCN1dEZEZMUVVTRXhIbFdGb1hJVSJ9.eyJodHRwOi8vYWRhZG90LmNvbS9vcmdhbml6YXRpb25JZCI6ImRlbW8tb3JnIiwiaHR0cDovL2FkYWRvdC5jb20vanRpIjoiYjNjMGRjYjItMTYxYi00ZDk2LWFhZmEtNjBmZDM3MTM2MDU1IiwiaHR0cDovL2FkYWRvdC5jb20vcGxhbnMiOlt7ImlkIjoic3ViXzFMQzFYdkM3MzVXTFk5dkJlQm5zWXpOZSIsIm5hbWUiOiJUZWFtIiwidHlwZSI6InRlYW0iLCJpc0FkbWluIjpmYWxzZSwic3RhdHVzIjoiYWN0aXZlIn1dLCJodHRwOi8vYWRhZG90LmNvbS9yZXNvdXJjZV9wZXJtaXNzaW9ucyI6WyJvcmc6KjpzdXBlci1hZG1pbiIsInd1Oio6c3VwZXItYWRtaW4iXSwiaHR0cDovL2FkYWRvdC5jb20vbWVyZ2VkX2lkZW50aXR5IjoiZGVtby11c2VyIiwiaHR0cDovL2FkYWRvdC5jb20vbG9naW5fbWV0aG9kX3ZlcmlmaWVkIjp0cnVlLCJuaWNrbmFtZSI6IkRlbW8gVXNlciIsIm5hbWUiOiJEZW1vIFVzZXIiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUxtNXd1MGI5bTZCYzA5Ui12NVlXdHo3RmNwSlRmMjhkbTBzckxfaUJRX1I9czk2LWMiLCJ1cGRhdGVkX2F0IjoiMjAyMy0wMS0xM1QxMToyNzo0Ny44NTFaIiwiZW1haWwiOiJkZW1vQGFkYWRvdC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6Ly9hZGFkb3QtcGxhdGZvcm0uZXUuYXV0aDAuY29tLyIsInN1YiI6ImRlbW8tdXNlciIsImF1ZCI6InpTVkh1OExHT0JoRWk5a2VNMVlyWWlpZWg5VTNHeFdJIiwiaWF0IjoxNjczNjA5MjcxLCJleHAiOjE2NzM2NDUyNzEsInNpZCI6IjNOV2lfTUY1TUtKNHVEdU9DTUFhQVZudU4wSV9JWC1FIn0.pgC0iLxb6tiHgxxJrV_NMsfpSHbHYgKaqU8ju9BQjw9yo4EcRNI60E0NHFM_KiV_k0MQDl8ryA5DYRDwI2JVTQ",
                                        access_token:
                                            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkVCN1dEZEZMUVVTRXhIbFdGb1hJVSJ9.eyJodHRwOi8vYWRhZG90LmNvbS9qdGkiOiJiM2MwZGNiMi0xNjFiLTRkOTYtYWFmYS02MGZkMzcxMzYwNTUiLCJpc3MiOiJodHRwczovL2FkYWRvdC1wbGF0Zm9ybS5ldS5hdXRoMC5jb20vIiwic3ViIjoiZGVtby11c2VyIiwiaWF0IjoxNjczNjA5MjcxLCJleHAiOjQxMDM1MjMwNzEsImF6cCI6InpTVkh1OExHT0JoRWk5a2VNMVlyWWlpZWg5VTNHeFdJIiwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCBvZmZsaW5lX2FjY2VzcyJ9.z-L4FkG2zoCZv8tK0Qf6jJRbxWbxN3W7lE9K8ggZNa0",
                                        expires_in: 86400,
                                    })
                                );
                            }}
                        >
                            Have a look around first
                        </ExternalLinkStyled>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LogInScreen;
